export default {
  data() {
    return {
      mixinNotification: null
    };
  },
  methods: {
    negativeNotification(
      message,
      timeout = 4000,
      textColor = "white",
      type = "negative",
      width = "600px",
    ) {
      this.mixinNotification = this.$q.notify({
        message,
        timeout,
        width,
        "text-color": textColor,
        type,
        progress: true,
       
        actions: [
          {
            icon: "close",
            color: textColor
          },
          { label: 'Report Error', color: 'white'}
        ]
      });
    },

    positiveNotification(
      message,
      timeout = 5000,
      textColor = "white",
      type = "positive",
    ) {
      this.mixinNotification = this.$q.notify({
        message,
        timeout,
        "text-color": textColor,
        progress: true,
        type,
        actions: [
          {
            icon: "close",
            color: textColor
          }
        ]
      });
    },

    globalNotification(
      message,
      validationState,
      timeout = 4000,
      textColor = "black",
    ) {
      console.log("globalNotification", message, validationState )
    const actions =  [
        {
          icon: "close",
          color: textColor
        },
      ]
       validationState === 2 && actions.push({ label: 'Report Error', color: 'white' }) 

      this.mixinNotification = this.$q.notify({
        message,
        timeout,
        "text-color": textColor,
        type: validationState === 0 ? 'positive' : validationState === 2 ? "negative" : "warning" ,
        progress: true,
        actions:actions,
      });
    },

    warningNotification(
      message,
      timeout = 4000,
      textColor = "black",
      type = "warning"
    ) {
      this.mixinNotification = this.$q.notify({
        message,
        timeout,
        "text-color": textColor,
        type,
        progress: true,
        actions: [
          {
            icon: "close",
            color: textColor
          }
        ]
      });
    },
    errorNotification(error) {
       console.log("errorNotification from Sales ->",error)
      let obj = error && error?.data?.errors;
      if(obj){
      Object.entries(obj).forEach(([key, value]) => {
        this.warningNotification(key + ' :  "' + value?.[0] + '"');
      });
    }
    }
  }
};
